import { render, staticRenderFns } from "./Lawsuit.vue?vue&type=template&id=740e5c8a&"
import script from "./Lawsuit.vue?vue&type=script&lang=js&"
export * from "./Lawsuit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports